module.exports = __webpack_public_path__ + "img/member-pic3.d712e8f5.png";